import { ExemptionQuestions } from "utils/types/exemption-questions";

export const commonGuards: {
	[key: string]: (context: ExemptionQuestions.FlowContext) => boolean;
} = {
	currentlyReceivingYes: context =>
		!!context.currentlyReceivingValue?.startsWith("yes") &&
		context.currentlyReceivingValue !== "yesButRecentlyRemoved",

	currentlyReceivingYesAtAnotherProperty: context =>
		!!context.currentlyReceivingValue?.startsWith("yesAnotherProperty"),

	currentlyReceivingYesAtAnotherPropertyInAnotherState: context =>
		context.currentlyReceivingValue === "yesAnotherPropertyInAnotherState",

	currentlyReceivingYesAtThisProperty: context =>
		context.currentlyReceivingValue === "yes",

	currentlyReceivingNoOrNotSure: context =>
		["no", "notSure", "yesButRecentlyRemoved"].includes(
			context.currentlyReceivingValue ?? ""
		),

	rareSituationsAbleToFile: context =>
		context.noneOfTheAbove === true ||
		context.specialFieldsValue?.is_active_duty_personnel === true,

	isPrimaryResidence: context => context.primaryResidenceValue === true,

	isNotPrimaryResidence: context => context.primaryResidenceValue === false,

	isSoleOwner: context => context.ownersValue === "Sole Owner",

	hasAdditionalOwners: context =>
		["Own With Spouse", "Other Persons"].includes(context.ownersValue ?? ""),

	isManufacturedHome: context => !!context?.use_info?.includes("Mobile"),
};
